<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.table">
  <div class="banner center" style="margin-top:10px;max-width: 810px;">
    <div class="row row_header freeze_col freeze_height">
      <div class="col-md-6">
        <button style="float: left;" class="button_icon button_icon_color"
          title="{{localService.languageContent.common.add}}" (click)="onClick(6)">note_add</button>
        <button style="float: left;" class="button_icon button_icon_color"
          title="{{localService.languageContent.common.add}}" (click)="onClick(7)">file_upload</button>
        {{localService.languageContent.table.name}}
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-6">
            <label style="font-weight: normal; margin-left: 15px;top: 3px; position: relative;">
              <input type="checkbox" [(ngModel)]="isArchive" (change)="onLoad()" />
              <span class="normal_color">&nbsp;</span>
            </label>
            {{localService.languageContent.table.last_login}}
          </div>
          <div class="col-6">
            {{localService.languageContent.table.contact_num}}
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="source">
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row styled_row freeze_col" *ngFor="let item of source.content.items">
          <div class="col-md-6">
            <a class="button" [routerLink]="['/my-access',localService.getLoginAsCountryCode(),item.key,4]"><i
                class="material-icons button icon_adjust">vpn_key</i></a>
            <button class="button_icon button_icon_color" style="top: 5px;"
              *ngIf="localService.selected.user != item.key" (click)="onClick(2,item.key)">
              manage_accounts
            </button>
            <span class="button" [ngStyle]="{'color' : item.v6 == '1' ? 'red' : ''}"
              [ngClass]="localService.getLanguageCode(item.v4)"
              (click)="localService.showSummaryWithCtry(item.key,1)">{{item.v3}}</span>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-6">
                <button class="button_icon button_icon_color" style="top: 5px;"
                  [ngStyle]="{'opacity' : item.v7 == '1' ? '0.5' : '1'}"
                  (click)="onActiveInactiveStatus(item.key,activeInactiveFor.ArchiveUser)">
                  {{item.v7 == '1' ? 'unarchive' : 'archive'}}
                </button>
                <span class="en">{{item.v5 | localDate}}</span>
              </div>
              <div class="col-6">
                <span class="en">{{item.v1}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="source && source.content" [paging]="source.content.paging" [IsShowDateRange]="true"
    (onPagingRefreshed)="onLoad()" (onCountryChanged)="onCountryUpdated($event)"></app-paging>
</div>
<div>
  <app-create-account *ngIf="source?.locations?.selected?.key" [(isOpenPopup)]="isOpenCreateAccount"
    [ctryCode]="source.locations.selected.key" (onClose)="onCloseCreateAccount($event)"></app-create-account>
  <app-bulk-upload [(isOpenPopup)]="isOpenBulkUserUpload" (onClose)="onCloseBulkUploadUser($event)"
    [excelTemplateType]="2"></app-bulk-upload>
  <span style="display: none;">
    <button class="on_as_country_changed" (click)="onChangeAsCountry()">As Country Changed</button>
  </span>
</div>